import {api} from '../api';
import {
    INTEGRATION_QB_TAXES_LOADED,
    INTEGRATION_QB_TERM_LOADED,
    INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM,
    INTEGRATION_QB_ACCOUNT_LOADED,
    INTEGRATION_QB_CLASS_LOADED,
    INTEGRATION_SET_QB_MODEL,
    INTEGRATION_QB_MODEL_UPDATED_BY_FORM,
    INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM
} from './types'

export const loadQbMapping = (jwt) => (dispatch) => {
    return api.integrations.loadQbMapping(jwt).then(res => {
        dispatch({
            type: INTEGRATION_SET_QB_MODEL,
            payload: res.data.data
        });
    }).catch(err => {
        throw err
    })
}

export const fetchQbTerms = (jwt, reload) => (dispatch) => {
    return api.integrations.fetchQbTerm(jwt, reload).then(res => {
        dispatch({
            type: INTEGRATION_QB_TERM_LOADED,
            payload: res.data.data
        })
        dispatch({
            type: INTEGRATION_QB_TERM_LOADED_ADD_TO_SYSTEM,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err
    })
}

export const fetchQbTaxes = (jwt, reload) => (dispatch) => {
    return api.integrations.fetchQbTax(jwt, reload).then(res => {
        dispatch({
            type: INTEGRATION_QB_TAXES_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err
    })
}

export const fetchQbAccounts = (jwt, reload) => (dispatch) => {
    return api.integrations.fetchQbAccount(jwt, reload).then(res => {
        dispatch({
            type: INTEGRATION_QB_ACCOUNT_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err
    })
}

export const fetchQbClasses = (jwt, reload) => (dispatch) => {
    return api.integrations.fetchQbClass(jwt, reload).then(res => {
        dispatch({
            type: INTEGRATION_QB_CLASS_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch(err => {
        throw err
    })
}

export const updateQbMappingModelInStore = (field, value) => {
    return ({
        type: INTEGRATION_QB_MODEL_UPDATED_BY_FORM,
        payload: {field, value}
    })
}

export const updateQbMappingTaxLine = (line_id, acct_id, acct_name) => {
    return ({
        type: INTEGRATION_QB_TAX_LINE_UPDATED_BY_FORM,
        payload: {line_id, acct_id, acct_name}
    })
}


// WEBPACK FOOTER //
// ./src/actions/qb.js